import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MotiveProiecteComponent } from './motive-proiecte.component';
import { AddMotiveProiecteComponent } from './add-motive-proiecte/add-motive-proiecte.component';
import { EditMotiveProiecteComponent } from './edit-motive-proiecte/edit-motive-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        MotiveProiecteComponent,
        AddMotiveProiecteComponent,
        EditMotiveProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [MotiveProiecteComponent]
})
export class MotiveProiecteModule { }
